import BlogPostListingCard from './BlogPostListingCard';

export default BlogPostListingCard;
